<ng-container *ngIf="currentStepper == 1">
    <app-roleplay-step1 ></app-roleplay-step1>
</ng-container>
<ng-container *ngIf="currentStepper == 2">
    <app-roleplay-step2></app-roleplay-step2>
</ng-container>
<ng-container *ngIf="currentStepper == 3">
    <app-roleplay-step3></app-roleplay-step3>
</ng-container>
<ng-container *ngIf="currentStepper == 4">
    <app-roleplay-step4></app-roleplay-step4>
</ng-container>
<ng-container *ngIf="currentStepper == 4">
    <app-roleplay-step5></app-roleplay-step5>
</ng-container>